import React from 'react';

import { InputReg } from '@interlayer/js/app/components/main/Registration/components/common/InputReg';

import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

import style from './MembershipField.scss';

export const MembershipField: React.FC = () => {
    return (
        <InputReg
            isOnlyNumber
            pattern="\d*"
            inputMode="numeric"
            name={VALIDATION_FIELDS.membershipNumber}
            classNames={{ isHoverEffect: style.isHoverEffect, error: style.error }}
        />
    );
};
